<template>
  <!-- create/update planning modal -->
  <div class="table-crud-modal price__modal" ref="modal">
    <h2 class="lvl2-heading">Modifier un prix concurrent</h2>
    <el-form
      :model="ruleForm"
      label-position="left"
      :status-icon="true"
      ref="editPriceForm"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            prop="selectedVideo"
            :rules="{
              required: true,
              message: 'La video est obligatoire',
              trigger: 'blur'
            }"
          >
            <el-select
              no-data-text="..."
              v-model="ruleForm.selectedVideo"
              placeholder="Liste de videos"
              filterable
            >
              <el-option
                v-for="video in videosList"
                :key="`video-${video.id}`"
                :label="video.title"
                :value="video.ean"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :prop="'price.pharmacie'"
              :rules="{
                required: true,
                message: 'La pharmacie est obligatoire',
                trigger: 'blur'
              }"
              label="Pharmacie"
            >
              <el-input
                placeholder="Nom de pharmacie"
                v-model="ruleForm.price.pharmacie"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :prop="'price.price'"
              :rules="[
                {
                  required: true,
                  message: 'Le prix est obligatoire',
                  trigger: 'blur'
                }
              ]"
              label="Prix"
            >
              <el-input
                type="number"
                placeholder="Prix"
                v-model="ruleForm.price.price"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-form-item style="text-align: right">
        <base-button @click.prevent.stop.native="handleSubmit" :fluid="false"
          >Modifier</base-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  Message,
  Input,
  Form,
  FormItem,
  Row,
  Col,
  Select,
  Option
} from "element-ui"
// import Multiselect from "@/components/MultiSelect"
import { mapGetters, mapState } from "vuex"
import { updateCompetitorPrice as updatePrice } from "@/api/competitorprice"
//import { getVideos as fetchVideos } from "@/api/videos"
import { loaderMixin } from "@/mixins"
import { emitter } from "@/utils"

export default {
  components: {
    ElInput: Input,
    ElForm: Form,
    ElFormItem: FormItem,
    ElRow: Row,
    ElCol: Col,
    ElSelect: Select,
    ElOption: Option
  },
  computed: {
    ...mapState(["videos"]),
    ...mapGetters(["modal"])
  },
  async mounted() {
    this.ruleForm.price = { ...this.modal.payload.price }
    this.ruleForm.selectedVideo = this.modal.payload.price.video_ean
    await this.$store.dispatch("getVideos")
    const { data } = this.videos.videos
    this.videosList = data
  },
  data() {
    return {
      ruleForm: {
        price: { pharmacie: null, price: null },
        selectedVideo: null
      },
      videosList: [],
      params: {}
    }
  },
  mixins: [loaderMixin],
  methods: {
    async handleSubmit() {
      this.openLoader(this.$refs.modal)
      this.$refs["editPriceForm"].validate(async valid => {
        if (valid) {
          try {
            await updatePrice(this.modal.payload.price.id, {
              ...this.ruleForm.price,
              video_ean: this.ruleForm.selectedVideo
            })
            Message.success("Prix créé(s)")
            emitter.$emit("update-table")
            this.$store.dispatch("closeModal")
            this.closeLoader()
          } catch {
            this.closeLoader()
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.price {
  &__modal {
    .el-form-item {
      margin: 0 !important;
    }
    .el-row {
      display: flex;
      align-items: center;
      margin: 20px 0;
    }
  }
  &__button {
    &-action {
      // background-color: #000;
      cursor: pointer;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px solid #fbac2e;
      border: 2px solid var(--color-secondary, #fbac2e);
      outline: none;
      color: white;
      -webkit-transition: all 0.2s ease;
      transition: all 0.2s ease;
      font-size: 25px;
      text-transform: uppercase;
      background: var(--color-secondary, #fbac2e);
      &:hover {
        box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.16);
      }
      &.marged {
        margin: 0 14px 20px auto;
      }
    }
  }
}
</style>
